import { useTranslation } from "react-i18next";

import { useGlobalConfig } from "@unauthenticated/shared/context";

const useTreatmentPlanTerm = (
  options: { plural?: boolean; capitalize?: boolean; recommended?: boolean } = {}
): string => {
  const { treatmentPlanTerm } = useGlobalConfig();
  const { t } = useTranslation();

  let key = `${treatmentPlanTerm}`;

  if (options.recommended) {
    key += "_past_participle";
  }

  if (options.capitalize) {
    key += "_capitalized";
  }

  return t(`common:${key}`, { count: options.plural ? 100 : 1 });
};

export { useTreatmentPlanTerm };
